// extracted by mini-css-extract-plugin
export default {"cc-popbox":"vjibbGTz","cc-popbox-block":"ozilHKJE","large-height":"G9X_Yf_I","cc-popbox-wrap":"URWV2W8f"};